package meineglasfaser.api

import kotlinx.serialization.Serializable
import meineglasfaser.api.ubl.UBLPostalAddress
import kotlin.time.Instant

enum class SurveyStatus {
    IN_PROGRESS,
    COMPLETED,
    CANCELLED;
}

@Serializable
data class SurveyInstallationType(
    val id: String,
    val title: String,
    val footnote: String,
    val requiresCountInput: Boolean,
)

@Serializable
data class SurveyInstallationOption(
    val id: String,
    val typeId: String,
    val title: String,
    val description: String,
    val priceText: String,
)

@Serializable
data class SurveyInstallationTypeWithOptions(
    val type: SurveyInstallationType,
    val options: List<SurveyInstallationOption>,
)

@Serializable
data class SurveyEntry(
    val id: String,
    val surveyId: String?,
    val customerId: String?,
    val name: String,
    val email: String,
    val phone: String,
    val installationType: SurveyInstallationType?,
    val installationOption: SurveyInstallationOption?,
    val installationCount: Int,
    val installationPriceText: String?,
    val installationAddress: UBLPostalAddress,
    val notes: String? = null,
    val notesExternal: String? = null,
    val createdAt: Instant? = null,
)

@Serializable
data class Survey(
    val id: String,
    val status: SurveyStatus,
    val title: String,
    val households: Int,
    val notes: String,
    val numAssignedEntries: Int? = null,
    val meta: EntityMeta? = null,
)

@Serializable
data class SurveyDashboardSurvey(
    val id: String,
    val title: String,
    val households: Int,
    val numAssignedEntries: Int,
)

@Serializable
data class SurveyDashboard(
    val surveys: Map<SurveyStatus, List<SurveyDashboardSurvey>>,
    val numUnassignedEntries: Int,
)
